import { Routes, Route, Navigate } from 'react-router-dom'

// Auth pages
import AuthPage from './app/auth/page'
import AuthConfirm from './app/auth/confirm/page'
import ForgotPassword from './app/auth/forgot-password/page'
import ResetPassword from './app/auth/reset-password/page'

// Dashboard pages
import LandlordDashboard from './app/dashboard/landlord/page'
import ClientDashboard from './app/dashboard/client/page'
import AdminDashboard from './app/admin/dashboard/page'
import LandlordEarningsPage from './app/landlord/earnings/page'

// Property pages
import PropertyDetails from './app/property/[id]/page'
import AdminPropertyDetails from './app/admin/properties/[id]/page'

// Payment pages
import PaymentSuccess from './app/payment/success/page'
import PaymentCancel from './app/payment/cancel/page'

// Legal pages
import TermsOfServicePage from './app/legal/terms/page'
import PrivacyPolicyPage from './app/legal/privacy/page'

// Home page
import HomePage from './app/page'

// Help page
import HelpPage from './app/help/page'

// Careers page
import CareersPage from './app/careers/page'

// Not found page
import NotFoundPage from './app/not-found'

// Protected route wrapper component
import ProtectedRoute from './components/ProtectedRoute'

import { AuthProvider } from '@/context/AuthContext'
import ToastProvider from '@/components/ToastProvider'
import ErrorBoundary from '@/components/ErrorBoundary'

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ToastProvider />
        <Routes>
      {/* Public routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/auth/confirm" element={<AuthConfirm />} />
      <Route path="/auth/forgot-password" element={<ForgotPassword />} />
      <Route path="/auth/reset-password" element={<ResetPassword />} />
      
      {/* Property routes */}
      <Route path="/property/:id" element={<PropertyDetails />} />
      
      {/* Help route */}
      <Route path="/help" element={<HelpPage />} />

      {/* Careers route */}
      <Route path="/careers" element={<CareersPage />} />
      
      {/* Legal routes */}
      <Route path="/legal/terms" element={<TermsOfServicePage />} />
      <Route path="/legal/privacy" element={<PrivacyPolicyPage />} />
      
      {/* Payment routes */}
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      
      {/* Protected Landlord routes */}
      <Route 
        path="/dashboard/landlord" 
        element={
          <ProtectedRoute allowedRoles={['landlord']}>
            <LandlordDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/landlord/earnings" 
        element={
          <ProtectedRoute allowedRoles={['landlord']}>
            <LandlordEarningsPage />
          </ProtectedRoute>
        } 
      />
      
      {/* Protected Client routes */}
      <Route 
        path="/dashboard/client" 
        element={
          <ProtectedRoute allowedRoles={['client']}>
            <ClientDashboard />
          </ProtectedRoute>
        } 
      />
      
      {/* Protected Admin routes */}
      <Route 
        path="/admin/dashboard" 
        element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin/properties/:id" 
        element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminPropertyDetails />
          </ProtectedRoute>
        } 
      />
      
      {/* 404 Not Found */}
      <Route path="/not-found" element={<NotFoundPage />} />
      <Route path="*" element={<Navigate to="/not-found" replace />} />
        </Routes>
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default App

